// import { App } from "vue";
// import ltSplitPanel from "./src/main.vue";

// ltSplitPanel.install = (app:App) => {
//   app.component("ltSplitPanel", ltSplitPanel);
// };
// export default ltSplitPanel;

import { withInstall } from "../../utils/install";
import SplitPanel from "./src/main.vue";
SplitPanel.name = "ltSplitPanel";
export const ltSplitPanel = withInstall(SplitPanel);
export default ltSplitPanel;


